import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

const detectInitialLang = () => {
  if (typeof window === "undefined") return "en";
  try {
    const saved = window.localStorage.getItem("dhon-lang");
    if (saved === "id" || saved === "en") return saved;
  } catch (_) {
    /* ignore */
  }
  const browser = (navigator.language || navigator.userLanguage || "en").toLowerCase();
  return browser.startsWith("id") ? "id" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() =>
    typeof window === "undefined" ? "en" : detectInitialLang(),
  );

  useEffect(() => {
    try {
      window.localStorage.setItem("dhon-lang", lang);
      document.documentElement.lang = lang;
    } catch (_) {
      /* ignore */
    }
  }, [lang]);

  const t = translations[lang] || translations.en;
  const toggle = () => setLang((prev) => (prev === "id" ? "en" : "id"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
